import httpStore from "@/api/httpStore.js";

export function getPopularProducts() {
  return httpStore
    .get("popular_products")
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
export function addProduct(code) {
  return httpStore.post("popular_products", { code }).then(() => {
    return;
  });
}
export function recalculatePopularity() {
  return httpStore.get(`products/recalculate_popularity`).then(res => {
    return res.data;
  });
}

// export function updateBanner(bannerId, newBanner) {
//   newBanner = JSON.parse(decamelize(JSON.stringify(newBanner)));
//   return httpStore
//     .put(`banners`, {
//       id: bannerId,
//       newBanner: newBanner
//     })
//     .then(res => {
//       return res.data;
//     })
//     .catch(e => {
//       throw e;
//     });
// }
// export function createBanner(newBanner) {
//   newBanner = JSON.parse(decamelize(JSON.stringify(newBanner)));
//   return httpStore
//     .post(`banners`, {
//       newBanner: newBanner
//     })
//     .then(res => {
//       return res.data;
//     })
//     .catch(e => {
//       throw e;
//     });
// }

export function deleteProduct(code) {
  return httpStore
    .delete(`popular_products?code=${code}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return {
        status: "error",
        message: e.response?.data?.message || e.message
      };
    });
}
